(function () {
  'use strict';
  if (window.FFCArtworkChecker) return;
  var instances = new WeakMap();
  var VERSION = 'dtf-2026-09-17';
  var MAX_EDIT_PIXELS = 10000000;
  function copy(image) { return { width: image.width, height: image.height, data: new Uint8ClampedArray(image.data) }; }
  function sha(file) {
    return file.arrayBuffer().then(function (buffer) { return crypto.subtle.digest('SHA-256', buffer); }).then(function (buffer) {
      return Array.from(new Uint8Array(buffer)).map(function (v) { return v.toString(16).padStart(2, '0'); }).join('');
    });
  }
  function dimensions(buffer) {
    var d = new DataView(buffer);
    if (d.byteLength >= 24 && d.getUint32(0) === 0x89504e47 && d.getUint32(4) === 0x0d0a1a0a) return [d.getUint32(16), d.getUint32(20)];
    if (d.byteLength < 4 || d.getUint16(0) !== 0xffd8) return null;
    var i = 2;
    while (i + 4 <= d.byteLength) {
      if (d.getUint8(i++) !== 255) return null;
      while (i < d.byteLength && d.getUint8(i) === 255) i++;
      var marker = d.getUint8(i++);
      if (marker === 0xda || marker === 0xd9) break;
      if (marker === 1 || (marker >= 0xd0 && marker <= 0xd7)) continue;
      if (i + 2 > d.byteLength) break;
      var length = d.getUint16(i);
      if (length < 2 || i + length > d.byteLength) break;
      if ([0xc0,0xc1,0xc2,0xc3,0xc5,0xc6,0xc7,0xc9,0xca,0xcb,0xcd,0xce,0xcf].indexOf(marker) !== -1 && length >= 7) return [d.getUint16(i + 5), d.getUint16(i + 3)];
      i += length;
    }
    return null;
  }
  function Checker(root, options) {
    this.root = root; this.options = options || {}; this.seq = 0; this.presets = ['chest'];
    this.embedded = root.hasAttribute('data-aq-embedded');
    this.strings = JSON.parse(root.querySelector('[data-aq-strings]').textContent);
    this.els = {};
    var self = this;
    ['preset','presets','result','status','metrics','reasons','ack','ack-wrap','help','image','canvas','preview','editor','tool','tools','tolerance','brush','contiguous','undo','apply','auto','reset','download','upscale','context','before','filename','empty','file-details','full-link','enhance','enhance-denoise','enhance-sharpen','enhance-alpha','enhance-comparison','enhance-before','enhance-after','enhance-use','enhance-keep','enhance-note'].forEach(function (k) { self.els[k] = root.querySelector('[data-aq-' + k + ']'); });
    if (!this.embedded) {
      var requested = new URLSearchParams(window.location.search).get('print_size');
      if (['chest','back','sleeve','neck'].indexOf(requested) !== -1) this.presets = [requested];
      if (this.els.preset) this.els.preset.value = this.presets[0];
    }
    this.fullLinkHref = this.els['full-link'] ? this.els['full-link'].getAttribute('href') : '';
    this.reset(); this.wire();
  }
  Checker.prototype.t = function (key) { return this.strings[key] || this.strings.check_failed; };
  Checker.prototype.showError = function (key) { this.els.status.hidden = false; this.els.status.textContent = this.t(key); };
  Checker.prototype.reset = function () {
    this.seq++; this.file = null; this.originalFile = null; this.original = null; this.current = null;
    this.meta = null; this.hash = ''; this.history = []; this.processed = false; this.dirty = false;
    this.enhancement = null; this.enhancementApplied = false; this.uploadPending = false;
    this.busy = false; this.error = ''; this.originalView = false; this.acceptedAt = ''; this.els.ack.checked = false;
    this.render();
  };
  Checker.prototype.notify = function () { if (this.options.onChange) this.options.onChange(this.snapshot()); };
  Checker.prototype.snapshot = function () {
    var results = this.results || [];
    var hasRed = results.some(function (r) { return r.status === 'red'; });
    var hasYellow = results.some(function (r) { return r.status === 'yellow'; });
    return { version: VERSION, status: hasRed ? 'red' : hasYellow ? 'yellow' : results.length ? 'green' : 'pending',
      ready: !!this.file && !this.busy && !this.dirty && !this.enhancement && !hasRed && !!results.length && (!hasYellow || !!this.acceptedAt),
      editingPending: !!this.file && (this.busy || this.dirty || !!this.enhancement),
      processed: this.processed, artworkSha256: this.hash, results: results,
      acknowledgement: this.acceptedAt ? { accepted: true, version: VERSION, artworkSha256: this.hash, acceptedAt: this.acceptedAt, presets: this.presets.slice() } : null };
  };
  Checker.prototype.invalidate = function () { this.acceptedAt = ''; this.els.ack.checked = false; };
  Checker.prototype.setPresets = function (presets, automatic) {
    var next = Array.from(new Set(presets.length ? presets : ['chest'])).sort();
    if (this.embedded) this.root.hidden = !automatic;
    if (this.els.preset) this.els.preset.closest('label').hidden = !!automatic;
    if (this.els.context) this.els.context.hidden = !automatic;
    if (next.join() === this.presets.join()) return;
    this.presets = next; this.invalidate(); this.render(); this.notify();
  };
  Checker.prototype.loadFile = async function (file) {
    this.reset(); var seq = this.seq; this.file = file; this.originalFile = file; this.busy = true; this.render(); this.notify();
    var url, canvas;
    try {
      if (!file.size || file.size > 15 * 1024 * 1024) throw new Error('too_large');
      if (!/\.(png|jpe?g)$/i.test(file.name)) throw new Error('manual_review');
      var buffer = await file.arrayBuffer(); var size = dimensions(buffer);
      if (!size) throw new Error('check_failed');
      if (!size[0] || !size[1] || size[0] * size[1] > 20000000) throw new Error('too_large');
      url = URL.createObjectURL(file); var img = new Image(); img.src = url; await img.decode();
      if (seq !== this.seq) return;
      canvas = document.createElement('canvas'); canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
      if (!canvas.width || !canvas.height || canvas.width * canvas.height > 20000000) throw new Error('too_large');
      var ctx = canvas.getContext('2d', { willReadFrequently: true }); ctx.drawImage(img, 0, 0);
      var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
      this.meta = window.FFCArtworkQualityCore.scanRGBA(pixels.data, pixels.width, pixels.height);
      // The compact panel retains evidence, not duplicate editable image buffers.
      if (!this.embedded) { this.current = pixels; this.original = copy(pixels); }
      pixels = null; canvas.width = canvas.height = 0;
      this.meta.format = 'png'; var hash = await sha(file);
      if (seq !== this.seq) return;
      this.hash = hash;
    } catch (e) { if (seq === this.seq) this.error = ['manual_review','too_large'].includes(e.message) ? e.message : 'check_failed'; }
    finally { if (canvas) canvas.width = canvas.height = 0; if (url) URL.revokeObjectURL(url); if (seq === this.seq) { this.busy = false; this.render(); this.notify(); } }
  };
  Checker.prototype.render = function () {
    var self = this, core = window.FFCArtworkQualityCore;
    var oldSignature = (this.results || []).map(function (r) { return r.status + ':' + r.ppi; }).join();
    this.results = this.file && !this.busy ? this.presets.map(function (p) {
      var r = self.error ? {status:'red',ppi:0,reasons:[self.error]} : core.analyse(self.meta || {empty:true}, p);
      r.preset = p; return r;
    }) : [];
    if (oldSignature !== this.results.map(function (r) { return r.status + ':' + r.ppi; }).join()) this.invalidate();
    var snapshot = this.snapshot(); this.els.result.dataset.status = snapshot.status;
    this.els.status.textContent = this.t(this.busy ? 'checking' : !this.file ? 'ui_pending' : 'ui_' + snapshot.status);
    this.els.status.hidden = !!this.els.presets && this.results.length > 0;
    if (this.els.presets) {
      this.els.presets.replaceChildren();
      this.results.forEach(function(result) {
        var p = result.preset, status = result.status;
        var row = document.createElement('div'); row.className = 'ffc-aq__status-row'; row.dataset.status = status; row.dataset.preset = p;
        var dot = document.createElement('span'); dot.className = 'ffc-aq__status-dot'; dot.setAttribute('aria-hidden','true'); dot.textContent = {green:'✓',yellow:'!',red:'×',pending:'…'}[status];
        var label = document.createElement('span'); label.className = 'ffc-aq__status-label'; label.textContent = self.t('ui_' + p);
        var text = document.createElement('span'); text.className = 'ffc-aq__status-text'; text.textContent = self.t('ui_' + status);
        row.append(dot,label,text); self.els.presets.appendChild(row);
      });
    }
    if (this.els['full-link'] && this.fullLinkHref) {
      var fullLink = new URL(this.fullLinkHref,window.location.href);
      fullLink.searchParams.set('print_size',this.presets.indexOf('back') !== -1 ? 'back' : this.presets[0]);
      this.els['full-link'].href = fullLink.href;
    }
    var reasons = Array.from(new Set(this.results.flatMap(function(r){return r.reasons || [];})));
    if (this.embedded) reasons = Array.from(new Set(reasons.map(function(reason) {
      return ['borderline_resolution','opaque_background','semi_transparency','processed','low_resolution'].indexOf(reason) !== -1 ? 'ui_' + reason : 'ui_attention';
    })));
    if (this.dirty) reasons.unshift('changed');
    if (this.enhancement) reasons.unshift('enhance_pending');
    if (this.els.reasons) {
      this.els.reasons.replaceChildren();
      reasons.forEach(function (reason) { var li = document.createElement('li'); li.textContent = self.t(reason); self.els.reasons.appendChild(li); });
    }
    this.els['ack-wrap'].hidden = snapshot.status !== 'yellow' || this.dirty || this.busy || !!this.enhancement;
    this.root.classList.toggle('is-busy', this.busy);
    if (this.embedded) return;
    if (this.els.filename) {
      var filename = this.file ? this.file.name : '';
      this.els.filename.textContent = filename.length > 60 ? filename.slice(0,39) + '…' + filename.slice(-20) : filename;
      this.els.filename.title = filename; this.els.filename.hidden = !this.file;
    }
    if (this.els.metrics) this.els.metrics.textContent = this.results.filter(function(r){return r.ppi > 0;}).map(function(r){return self.t(r.preset) + ': ' + Math.round(r.ppi) + ' ' + self.t('ppi_label') + ' · ' + r.widthMm.toFixed(1) + ' × ' + r.heightMm.toFixed(1) + ' mm';}).join(' / ');
    if (this.els['file-details']) this.els['file-details'].hidden = !this.file;
    if (this.els.help) this.els.help.hidden = !this.file || this.busy || snapshot.status === 'green';
    this.els.image.hidden = !this.current;
    if (this.els.empty) this.els.empty.hidden = !!this.current;
    var editable = this.current && this.current.width * this.current.height <= MAX_EDIT_PIXELS;
    if (this.els.tools) this.els.tools.hidden = !editable;
    ['auto','reset','undo','apply'].forEach(function(k){self.els[k].disabled = self.busy || !!self.enhancement || !editable || (k==='undo' && !self.history.length) || (k==='apply' && (!self.dirty || self.uploadPending));});
    this.els.download.disabled = this.els.upscale.disabled = this.busy || !!this.enhancement || !this.current;
    if (this.els.enhance) {
      this.els.enhance.disabled = this.busy || !editable || !!this.enhancement || this.enhancementApplied;
      this.els['enhance-use'].disabled = this.busy || !this.enhancement || this.uploadPending;
      this.els['enhance-keep'].disabled = this.busy || !this.enhancement;
      this.els['enhance-comparison'].hidden = !this.enhancement;
      this.els['enhance-note'].textContent = this.enhancementApplied ? this.t('enhance_done') : this.t('enhance_help');
      ['enhance-denoise','enhance-sharpen','enhance-alpha'].forEach(function(k){self.els[k].disabled=self.busy || !!self.enhancement || self.enhancementApplied;});
      if (this.enhancement) {
        this.drawImage(this.current,this.els['enhance-before']);
        this.drawImage(this.enhancement,this.els['enhance-after']);
      }
    }
    if (this.current && !editable && this.els.reasons) { var limit = document.createElement('li'); limit.textContent = this.t('edit_limit'); this.els.reasons.appendChild(limit); }
    this.draw();
  };
  Checker.prototype.draw = function () {
    if (!this.current) return;
    var image = this.originalView ? this.original : this.current;
    this.drawImage(image,this.els.canvas);
  };
  Checker.prototype.drawImage = function (image,canvas) {
    var full = document.createElement('canvas'); full.width = image.width; full.height = image.height;
    full.getContext('2d').putImageData(new ImageData(image.data, image.width, image.height), 0, 0);
    var ratio = Math.min(1, 768 / image.width, 480 / image.height);
    canvas.width = Math.max(1, Math.round(image.width * ratio)); canvas.height = Math.max(1, Math.round(image.height * ratio));
    canvas.getContext('2d').drawImage(full, 0, 0, canvas.width, canvas.height); full.width = full.height = 0;
  };
  Checker.prototype.saveUndo = function () {
    var limit = this.current.width * this.current.height > 8000000 ? 1 : 2;
    while (this.history.length >= limit) this.history.shift();
    this.history.push(copy(this.current));
  };
  Checker.prototype.edit = function (x, y, edges, recordUndo) {
    if (!this.current || this.busy || this.enhancement || this.current.width * this.current.height > MAX_EDIT_PIXELS || this.originalView) return;
    var core = window.FFCArtworkQualityCore;
    try {
      if (recordUndo !== false) this.saveUndo();
      var tool = edges ? 'remove' : this.els.tool.value;
      if (tool === 'remove') {
        var opts = { tolerance: Number(this.els.tolerance.value), contiguous: this.els.contiguous.checked };
        if (!edges) { opts.x = x; opts.y = y; }
        this.current = core.removeBackground(this.current, opts);
      } else this.current = core.applyBrush(this.current, this.original, {x:x,y:y,radius:Number(this.els.brush.value) * this.current.width / this.els.canvas.width,mode:tool,hardness:1});
    } catch (e) {
      this.showError('edit_failed');
      return;
    }
    this.dirty = true; this.invalidate(); this.render(); this.notify();
  };
  Checker.prototype.enhance = async function () {
    if (!this.current || this.busy || this.enhancement || this.enhancementApplied || this.current.width*this.current.height>MAX_EDIT_PIXELS) return;
    var seq=this.seq;this.busy=true;this.invalidate();this.render();this.notify();
    try {
      await new Promise(function(resolve){requestAnimationFrame(function(){setTimeout(resolve,0);});});
      if(seq!==this.seq)return;
      this.enhancement=window.FFCArtworkQualityCore.gentlyEnhance(this.current,{
        denoise:this.els['enhance-denoise'].checked,sharpen:this.els['enhance-sharpen'].checked,refineAlpha:this.els['enhance-alpha'].checked
      });
    } catch(e){if(seq===this.seq)this.enhancement=null;}
    finally {
      if(seq===this.seq){this.busy=false;this.render();this.notify();if(!this.enhancement)this.showError('edit_failed');}
    }
  };
  Checker.prototype.keepCurrent = function () {
    if(this.busy || !this.enhancement)return;
    this.enhancement=null;this.invalidate();this.render();this.notify();
  };
  Checker.prototype.useEnhancement = async function () {
    if(this.busy || this.uploadPending || !this.enhancement)return;
    try {this.saveUndo();} catch(e){this.showError('edit_failed');return;}
    this.current=this.enhancement;this.enhancement=null;this.enhancementApplied=true;this.originalView=false;
    this.dirty=true;this.invalidate();await this.apply();
  };
  Checker.prototype.exportFile = async function (scale) {
    var source = this.current;
    var originalName = this.originalFile ? this.originalFile.name : 'artwork.png';
    if (!source || source.width * source.height * scale * scale > 20000000) throw new Error('export_failed');
    var canvas = document.createElement('canvas'); canvas.width = source.width; canvas.height = source.height;
    canvas.getContext('2d').putImageData(new ImageData(source.data,source.width,source.height),0,0);
    var out = canvas;
    if (scale !== 1) { out = document.createElement('canvas'); out.width = source.width*scale; out.height = source.height*scale; var ctx=out.getContext('2d'); ctx.imageSmoothingQuality='high'; ctx.drawImage(canvas,0,0,out.width,out.height); }
    var blob = await new Promise(function(resolve){out.toBlob(resolve,'image/png');}); canvas.width=canvas.height=0; out.width=out.height=0;
    if (!blob || blob.size > 15*1024*1024) throw new Error('export_failed');
    return new File([blob], originalName.replace(/\.[^.]+$/,'') + (scale===2?'_2x-source-quality-unchanged':'_dtf-edited') + '.png', {type:'image/png'});
  };
  Checker.prototype.apply = async function () {
    if (!this.dirty || this.busy || this.enhancement || this.uploadPending) return;
    var seq=this.seq; this.busy=true; this.render(); this.notify();
    try {
      var file=await this.exportFile(1); var hash=await sha(file); if(seq!==this.seq)return;
      this.file=file; this.hash=hash; this.processed=true; this.dirty=false; this.error='';
      this.meta=window.FFCArtworkQualityCore.scanRGBA(this.current.data,this.current.width,this.current.height);
      this.meta.format='png'; this.meta.processed=true; this.meta.sourceWidth=this.original.width; this.meta.sourceHeight=this.original.height;
      if(this.options.onApply) await this.options.onApply(file);
    } catch(e) { if(seq===this.seq){this.error='export_failed';} }
    finally { if(seq===this.seq){this.busy=false;this.render();this.notify();} }
  };
  Checker.prototype.download = async function (scale) {
    try { var file=await this.exportFile(scale); var url=URL.createObjectURL(file); var a=document.createElement('a');a.href=url;a.download=file.name;a.click();setTimeout(function(){URL.revokeObjectURL(url);},1000); }
    catch(e){this.showError('export_failed');}
  };
  Checker.prototype.wire = function () {
    var self=this, file=this.root.querySelector('[data-aq-file]');
    this.els.ack.addEventListener('change',function(){self.acceptedAt=self.els.ack.checked?new Date().toISOString():'';self.notify();});
    if (this.embedded) return;
    if(file)file.addEventListener('change',function(){if(file.files[0])self.loadFile(file.files[0]);file.value='';});
    this.els.preset.addEventListener('change',function(){self.setPresets([self.els.preset.value],false);});
    if(this.els.enhance){
      this.els.enhance.addEventListener('click',function(){self.enhance();});
      this.els['enhance-use'].addEventListener('click',function(){self.useEnhancement();});
      this.els['enhance-keep'].addEventListener('click',function(){self.keepCurrent();});
    }
    this.root.querySelector('[data-aq-background]').addEventListener('click',function(){self.els.preview.classList.toggle('is-dark');});
    this.els.before.addEventListener('click',function(){self.originalView=!self.originalView;self.els.before.setAttribute('aria-pressed',String(self.originalView));self.draw();});
    var dragging = false, lastPoint = null, lastMove = 0;
    function editorOpen() { return self.els.editor.open && (!self.els.tools || self.els.tools.open); }
    function syncEditor() {
      var open = editorOpen(); self.root.classList.toggle('is-editing',open);
      if (!open) dragging = false;
    }
    this.els.editor.addEventListener('toggle',syncEditor);
    if (this.els.tools) this.els.tools.addEventListener('toggle',syncEditor);
    function point(e) {
      var rect = self.els.canvas.getBoundingClientRect();
      return {x:Math.min(self.current.width-1,Math.max(0,Math.floor((e.clientX-rect.left)/rect.width*self.current.width))),y:Math.min(self.current.height-1,Math.max(0,Math.floor((e.clientY-rect.top)/rect.height*self.current.height)))};
    }
    this.els.canvas.addEventListener('pointerdown',function(e){
      if(!editorOpen() || !self.current)return; e.preventDefault();lastPoint=point(e);
      self.edit(lastPoint.x,lastPoint.y,false);dragging=self.els.tool.value!=='remove';
      if(dragging)self.els.canvas.setPointerCapture(e.pointerId);
    });
    this.els.canvas.addEventListener('pointermove',function(e){
      if(!editorOpen()){dragging=false;return;}
      if(!dragging || !self.current || performance.now()-lastMove<60)return;lastMove=performance.now();lastPoint=point(e);self.edit(lastPoint.x,lastPoint.y,false,false);
    });
    this.els.canvas.addEventListener('pointerup',function(){dragging=false;});
    this.els.canvas.addEventListener('pointercancel',function(){dragging=false;});
    this.els.canvas.addEventListener('keydown',function(e){
      if(!editorOpen() || !self.current)return;
      if(!lastPoint)lastPoint={x:Math.floor(self.current.width/2),y:Math.floor(self.current.height/2)};
      var step=Math.max(1,Math.round(self.current.width/100));
      if(e.key==='ArrowLeft')lastPoint.x=Math.max(0,lastPoint.x-step);
      else if(e.key==='ArrowRight')lastPoint.x=Math.min(self.current.width-1,lastPoint.x+step);
      else if(e.key==='ArrowUp')lastPoint.y=Math.max(0,lastPoint.y-step);
      else if(e.key==='ArrowDown')lastPoint.y=Math.min(self.current.height-1,lastPoint.y+step);
      else if(e.key==='Enter' || e.key===' ')self.edit(lastPoint.x,lastPoint.y,false);
      else return;
      e.preventDefault();self.els.canvas.title=String(lastPoint.x)+', '+String(lastPoint.y);
    });
    this.els.auto.addEventListener('click',function(){self.edit(0,0,true);});
    this.els.undo.addEventListener('click',function(){if(!self.history.length || self.busy || self.enhancement)return;self.current=self.history.pop();self.dirty=true;self.invalidate();self.render();self.notify();});
    this.els.reset.addEventListener('click',function(){if(!self.original || self.busy || self.enhancement)return;self.saveUndo();self.current=copy(self.original);self.enhancementApplied=false;self.dirty=true;self.originalView=false;self.invalidate();self.render();self.notify();});
    this.els.apply.addEventListener('click',function(){self.apply();});
    this.els.download.addEventListener('click',function(){self.download(1);});this.els.upscale.addEventListener('click',function(){self.download(2);});
  };
  window.FFCArtworkChecker={attach:function(root,options){if(!instances.has(root))instances.set(root,new Checker(root,options));return instances.get(root);},dimensions:dimensions};
  function boot(){document.querySelectorAll('[data-ffc-artwork-checker]:not([data-aq-embedded])').forEach(function(root){window.FFCArtworkChecker.attach(root);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
